import { render } from "./AppHeader.vue?vue&type=template&id=6061381e&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=6061381e&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\TaleMakerWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6061381e"]])

export default __exports__